// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.message-form {
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    margin: 10px 8px 0 8px;
    transition: 0.3s;
    padding: 0 0 2px 0;
}

.message-form:focus-within {
    border-bottom: 2px solid #3f51b5;
}

.message-form .message-form__send,
.message-form .message-form__input {
    outline: none;
    border: none;
}

    .message-form .message-form__input {
        flex: 1 1 auto;
    }

.message-form .message-form__input:hover,
.message-form .message-form__input:focus {
    border: none !important;
    box-shadow: none !important;
}

    .message-form .message-form__send {
        background: none;
        box-shadow: none;
        padding: 0 0 6px 0;
    }

.message-form .message-form__send:hover {
    border: none;
    box-shadow: none;
}

.message-form__send .material-icons {
    color: #718093;
    transition: 0.3s;
}

.message-form__send .material-icons:hover {
    color: #2f3640;
}

.message-form textarea.scalable-text-input {
    display: block;
    width: 100%;
    max-height: 70px;
    margin: 0;
    padding: 6px 0 5px 0;
    overflow-y: auto;
}`, "",{"version":3,"sources":["webpack://./src/app/nlp/topic-editor/topic-widget/message-input/MessageInput.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;;IAEI,aAAa;IACb,YAAY;AAChB;;IAEI;QACI,cAAc;IAClB;;AAEJ;;IAEI,uBAAuB;IACvB,2BAA2B;AAC/B;;IAEI;QACI,gBAAgB;QAChB,gBAAgB;QAChB,kBAAkB;IACtB;;AAEJ;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,SAAS;IACT,oBAAoB;IACpB,gBAAgB;AACpB","sourcesContent":[".message-form {\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: flex-end;\r\n    margin: 10px 8px 0 8px;\r\n    transition: 0.3s;\r\n    padding: 0 0 2px 0;\r\n}\r\n\r\n.message-form:focus-within {\r\n    border-bottom: 2px solid #3f51b5;\r\n}\r\n\r\n.message-form .message-form__send,\r\n.message-form .message-form__input {\r\n    outline: none;\r\n    border: none;\r\n}\r\n\r\n    .message-form .message-form__input {\r\n        flex: 1 1 auto;\r\n    }\r\n\r\n.message-form .message-form__input:hover,\r\n.message-form .message-form__input:focus {\r\n    border: none !important;\r\n    box-shadow: none !important;\r\n}\r\n\r\n    .message-form .message-form__send {\r\n        background: none;\r\n        box-shadow: none;\r\n        padding: 0 0 6px 0;\r\n    }\r\n\r\n.message-form .message-form__send:hover {\r\n    border: none;\r\n    box-shadow: none;\r\n}\r\n\r\n.message-form__send .material-icons {\r\n    color: #718093;\r\n    transition: 0.3s;\r\n}\r\n\r\n.message-form__send .material-icons:hover {\r\n    color: #2f3640;\r\n}\r\n\r\n.message-form textarea.scalable-text-input {\r\n    display: block;\r\n    width: 100%;\r\n    max-height: 70px;\r\n    margin: 0;\r\n    padding: 6px 0 5px 0;\r\n    overflow-y: auto;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
